export class RiskFilterType {
  id: FilterTypes;
  controlType?: FilterControlTypes;
  label?: string;
  value: string | string[] | Date;
  filterOption?: FilterSearchOptions = FilterSearchOptions.searchStartsWith;
  index: number;

  constructor(id: FilterTypes, controlType: FilterControlTypes, label: string) {
    this.id = id;
    this.controlType = controlType;
    this.label = label;
  }
}

export class FilterListItem {
  index: number;
  label: string;
  filterTypeId: FilterTypes;
  visible: boolean;

  constructor(index: number, label: string, filterTypeId: FilterTypes, visible: boolean = false) {
    this.index = index;
    this.label = label;
    this.filterTypeId = filterTypeId;
    this.visible = visible;
  }
}

export class SelectFilterOption {
  name: string;
  id: string;
  selected: boolean;

  constructor(id: string, name: string, selected: boolean = false) {
    this.id = id;
    this.name = name;
    this.selected = selected;
  }
}

export enum FilterControlTypes {
  input = 'INPUT',
  inputWithOptions = 'INPUT_WITH_OPTIONS',
  multiselect = 'MULTISELECT',
  date = 'DATE'
}

export enum FilterTypes {
  none,
  name,
  lastName,
  userDepartment,
  departmentByName,
  userLocation,
  userRole,
  locationByName,
  userId,
  employeeId,
  email,
  login,
  userTitle,
  userTeam,
  category,
  userStatus,
  ansTypeUser,
  ansTypeVendor,
  userRPXMobile,
  departmentId,
  parentDepartment,
  parentResource,
  plan,
  function,
  resourceId,
  siteType,
  siteId,
  siteRegion,
  siteState,
  siteCountry,
  siteCity,
  contractExpiresAfter,
  contractExpiresBefore,
  contractName,
  contactName,
  contactEmail,
  uniqueId,
  entityTypeArea,
  userManagerRole,
  resource,
  firstName,
  site,
  relationship
}

export enum FilterSearchOptions {
  searchStartsWith = 0,
  searchContains = 1
}
